export default __webpack_public_path__ + "static/media/img-button-event.b2e53204.png";